import React from 'react';
import './Pages.css';

const Disclaimer = () => {
  return React.createElement(
    'main',
    { className: 'page-content' },
    React.createElement(
      'div',
      { className: 'container' },
      React.createElement('h1', null, 'Disclaimer'),
      React.createElement('p', null, 'The information provided on InfoNaukri.com is for general informational purposes only...'),
      React.createElement('h3', null, 'No Professional Advice'),
      React.createElement('p', null, 'The content on this website is not intended as professional career advice...'),
      React.createElement('h3', null, 'External Links'),
      React.createElement('p', null, 'We may contain links to third-party websites. We are not responsible for their content or practices...'),
      React.createElement('h3', null, 'Limitation of Liability'),
      React.createElement('p', null, 'InfoNaukri shall not be liable for any damages arising from the use of this website...')
    )
  );
};

export default Disclaimer;